import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-application-cog',
  templateUrl: './icon-application-cog.component.html',
  styleUrl: './icon-application-cog.component.scss',
  standalone: false,
})
export class IconApplicationCogComponent {
  @Input() tooltip?: string;
}
